/**
 * A statement ID looks like: "1601575683AS0006468120193A"
 * The last five numbers form a year / quarter, i.e. "20193" for the above id, which represents
 * year 2019, quarter 3.
 *
 * Given a statement ID, return a number that represents the parsed year and quarter together, i.e.
 * `20193` for the above statement ID.
 * @param statementId
 */
export const getYQFromStatementId = (statementId: string): number | null => {
    let yearAndQuarter = 0;

    try {
        yearAndQuarter = parseInt(
            statementId.slice(statementId.length - 6, statementId.length - 1),
            10,
        );

        return yearAndQuarter;
    } catch {
        return null;
    }
};
